var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g2, _g3, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTractorBeam3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 142,
    viewBox: "0 0 144 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M72.0001 60.1441C88.4682 60.1441 101.818 46.7941 101.818 30.3261C101.818 13.858 88.4682 0.508057 72.0001 0.508057C55.5321 0.508057 42.1821 13.858 42.1821 30.3261C42.1821 46.7941 55.5321 60.1441 72.0001 60.1441Z",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 57.4601C86.9853 57.4601 99.1332 45.3122 99.1332 30.3271C99.1332 15.3419 86.9853 3.19409 72.0002 3.19409C57.015 3.19409 44.8672 15.3419 44.8672 30.3271C44.8672 45.3122 57.015 57.4601 72.0002 57.4601Z",
    fill: "#00FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 53.1051C84.5801 53.1051 94.7782 42.907 94.7782 30.3271C94.7782 17.7471 84.5801 7.54907 72.0002 7.54907C59.4202 7.54907 49.2222 17.7471 49.2222 30.3271C49.2222 42.907 59.4202 53.1051 72.0002 53.1051Z",
    fill: "#C7FFFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17824 28.8334L3.21206 29.6091C2.90455 29.8559 2.85539 30.3053 3.10225 30.6128L8.42717 37.2459C8.67403 37.5534 9.12342 37.6025 9.43093 37.3557L10.3971 36.58C10.7046 36.3332 10.7538 35.8838 10.5069 35.5763L5.182 28.9432C4.93514 28.6357 4.48574 28.5866 4.17824 28.8334Z",
    fill: "#101016"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03125 30.3271L16.1412 8.06506",
    stroke: "#101016",
    strokeWidth: 1.671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0169 2.23318C18.2692 2.82968 19.2332 3.89921 19.6969 5.20649C20.1606 6.51377 20.086 7.95171 19.4895 9.20398L18.6952 10.8715C18.5721 11.13 18.3514 11.3291 18.0816 11.4251C17.8118 11.5211 17.515 11.5061 17.2562 11.3834L13.6278 9.65507C13.369 9.53178 13.1697 9.31072 13.0739 9.04051C12.9781 8.77031 12.9935 8.4731 13.1168 8.21426L15.752 2.68184C15.8603 2.45461 16.0544 2.27969 16.2916 2.19555C16.5288 2.11141 16.7897 2.12494 17.0169 2.23318V2.23318Z",
    fill: "#4A4A5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0872 19.2001L12.1792 22.8L7.84619 33.1001",
    stroke: "#101016",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5707 42.736L14.2549 37.36L8.9249 41.6389L13.2407 47.0149L18.5707 42.736Z",
    stroke: "#101016",
    strokeWidth: 1.671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37103 29.31L2.43408 28.856C2.55772 28.8028 2.69545 28.7921 2.82586 28.8253C2.95627 28.8586 3.07204 28.9341 3.15509 29.04L17.4551 47.183L16.2551 48.94C15.8057 49.5999 15.2019 50.14 14.4963 50.5133C13.7906 50.8866 13.0044 51.0818 12.206 51.082C11.453 51.0818 10.7102 50.908 10.0352 50.5742C9.36023 50.2403 8.77128 49.7554 8.31408 49.157L2.41406 41.433L0.996028 29.948C0.98014 29.8153 1.00825 29.681 1.07598 29.5658C1.14372 29.4505 1.24734 29.3607 1.37103 29.31Z",
    fill: "url(#paint0_linear_1277_371)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7402 45.5311L12.1911 36.8071C12.1032 36.6901 12.0542 36.5484 12.051 36.402C12.0477 36.2556 12.0904 36.1119 12.1731 35.9911L13.8482 33.5431L22.3371 44.8521L19.5192 45.7761C19.38 45.8219 19.23 45.8229 19.0903 45.779C18.9505 45.735 18.828 45.6483 18.7402 45.5311Z",
    fill: "#101016"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.603 36.5804L134.569 37.3561C134.877 37.6029 135.326 37.5538 135.573 37.2463L140.898 30.6132C141.145 30.3057 141.096 29.8563 140.788 29.6094L139.822 28.8338C139.514 28.587 139.065 28.6361 138.818 28.9436L133.493 35.5767C133.246 35.8842 133.296 36.3336 133.603 36.5804Z",
    fill: "#101016"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.968 30.327L127.858 8.065",
    stroke: "#101016",
    strokeWidth: 1.671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.373 9.65487L126.745 11.3832C126.486 11.5059 126.189 11.5209 125.919 11.4249C125.65 11.3289 125.429 11.1298 125.306 10.8713L124.512 9.20468C124.217 8.58462 124.046 7.91246 124.011 7.22656C123.975 6.54067 124.075 5.85449 124.305 5.20719C124.534 4.55989 124.889 3.96416 125.349 3.45399C125.809 2.94383 126.364 2.52924 126.985 2.23388C127.212 2.12572 127.472 2.11212 127.709 2.19608C127.947 2.28004 128.141 2.45468 128.249 2.68164L130.884 8.21406C131.008 8.4729 131.023 8.77011 130.927 9.04031C130.831 9.31052 130.632 9.53158 130.373 9.65487Z",
    fill: "#4A4A5B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.913 19.2L131.821 22.8L136.154 33.1",
    stroke: "#101016",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.759 47.015L135.075 41.639L129.745 37.3602L125.429 42.7362L130.759 47.015Z",
    stroke: "#101016",
    strokeWidth: 1.671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.629 29.31L141.566 28.856C141.442 28.8028 141.305 28.7921 141.174 28.8253C141.044 28.8586 140.928 28.9341 140.845 29.04L126.545 47.183L127.745 48.94C128.194 49.5999 128.798 50.14 129.504 50.5133C130.209 50.8866 130.996 51.0818 131.794 51.082C132.547 51.0818 133.29 50.908 133.965 50.5742C134.64 50.2403 135.229 49.7554 135.686 49.157L141.586 41.433L143.004 29.948C143.02 29.8153 142.992 29.681 142.924 29.5658C142.856 29.4505 142.753 29.3607 142.629 29.31Z",
    fill: "url(#paint1_linear_1277_371)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.26 45.531L131.809 36.807C131.897 36.69 131.946 36.5483 131.949 36.4019C131.953 36.2555 131.91 36.1118 131.827 35.991L130.152 33.543L121.663 44.852L124.481 45.776C124.62 45.8218 124.77 45.8229 124.91 45.7789C125.05 45.7349 125.172 45.6483 125.26 45.531Z",
    fill: "#101016"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7239 26.821V18.761H34.3649L30.335 24.167V26.821H36.7239Z",
    fill: "url(#paint2_linear_1277_371)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.276 26.821V18.761H109.635L113.665 24.167V26.821H107.276Z",
    fill: "url(#paint3_linear_1277_371)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5291 26.821H34.0781L35.0921 21.304C35.1199 21.1516 35.2004 21.0139 35.3193 20.9146C35.4383 20.8154 35.5882 20.761 35.7431 20.761H37.5291V26.821Z",
    fill: "#4A4A5B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.471 26.821H109.922L108.908 21.304C108.88 21.1516 108.8 21.0139 108.681 20.9146C108.562 20.8154 108.412 20.761 108.257 20.761H106.471V26.821Z",
    fill: "#4A4A5B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5308 22.791H107.47",
    stroke: "#9A9AB7",
    strokeWidth: 1.114,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.251 21.612L78.324 19.941H65.676L55.749 21.612L53 26.821H91L88.251 21.612Z",
    fill: "#4A4A5B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.377 17.238H61.623L59.395 26.821H84.606L82.377 17.238Z",
    fill: "url(#paint4_linear_1277_371)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3734 69.2001L36.0734 77.5001C35.7813 77.7919 35.5496 78.1384 35.3915 78.5199C35.2335 78.9013 35.1522 79.3102 35.1523 79.7231V109.075C35.1522 109.488 35.2335 109.897 35.3915 110.278C35.5496 110.66 35.7813 111.006 36.0734 111.298L42.0674 117.293",
    stroke: "#1B1B24",
    strokeWidth: 2.228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4683 121.106L43.9803 121.03L42.5563 111.392L42.0443 111.468L40.4873 113.568L41.3713 119.552L43.4683 121.106Z",
    fill: "url(#paint5_linear_1277_371)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.97 75.1501H45.4871V65.4071H44.97L43.123 67.2541V73.3001L44.97 75.1501Z",
    fill: "url(#paint6_linear_1277_371)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7423 81.9271H33.5543C33.3687 81.9271 33.2183 82.0776 33.2183 82.2631V84.0481C33.2183 84.2337 33.3687 84.3841 33.5543 84.3841H36.7423C36.9278 84.3841 37.0783 84.2337 37.0783 84.0481V82.2631C37.0783 82.0776 36.9278 81.9271 36.7423 81.9271Z",
    fill: "#1B1B24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7423 85.6781H33.5543C33.3687 85.6781 33.2183 85.8285 33.2183 86.0141V87.7991C33.2183 87.9847 33.3687 88.1351 33.5543 88.1351H36.7423C36.9278 88.1351 37.0783 87.9847 37.0783 87.7991V86.0141C37.0783 85.8285 36.9278 85.6781 36.7423 85.6781Z",
    fill: "#1B1B24"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.627 69.2001L107.927 77.5001C108.219 77.7919 108.451 78.1384 108.609 78.5199C108.767 78.9013 108.848 79.3102 108.848 79.7231V109.075C108.848 109.488 108.767 109.897 108.609 110.278C108.451 110.66 108.219 111.006 107.927 111.298L101.933 117.293",
    stroke: "#1B1B24",
    strokeWidth: 2.228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M100.532 121.106L100.02 121.03L101.444 111.392L101.956 111.468L103.513 113.568L102.629 119.552L100.532 121.106Z",
    fill: "url(#paint7_linear_1277_371)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0302 75.1501H98.5132V65.4071H99.0302L100.877 67.2541V73.3001L99.0302 75.1501Z",
    fill: "url(#paint8_linear_1277_371)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M107.258 84.384H110.446C110.632 84.384 110.782 84.2336 110.782 84.048V82.263C110.782 82.0775 110.632 81.927 110.446 81.927H107.258C107.073 81.927 106.922 82.0775 106.922 82.263V84.048C106.922 84.2336 107.073 84.384 107.258 84.384Z",
    fill: "#1B1B24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.258 88.1361H110.446C110.632 88.1361 110.782 87.9857 110.782 87.8001V86.0151C110.782 85.8295 110.632 85.6791 110.446 85.6791H107.258C107.073 85.6791 106.922 85.8295 106.922 86.0151V87.8001C106.922 87.9857 107.073 88.1361 107.258 88.1361Z",
    fill: "#1B1B24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.1 26.5431L131.57 30.8011C127.976 48.1711 102.678 61.6311 72.0031 61.6311C41.3281 61.6311 16.03 48.1711 12.436 30.8011L15.9061 26.5431H128.1Z",
    fill: "url(#paint9_radial_1277_371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M14.5669 30.8H129.433C129.625 30.8004 129.813 30.7462 129.975 30.6438C130.137 30.5415 130.267 30.3951 130.349 30.2219C130.432 30.0486 130.463 29.8555 130.44 29.665C130.417 29.4746 130.34 29.2946 130.219 29.1461L128.401 26.9151C128.306 26.7984 128.186 26.7044 128.05 26.6399C127.914 26.5754 127.765 26.5419 127.615 26.5421H16.3849C16.2344 26.5419 16.0857 26.5754 15.9498 26.6399C15.8138 26.7044 15.6939 26.7984 15.5989 26.9151L13.7809 29.1461C13.6595 29.2946 13.5827 29.4746 13.5596 29.665C13.5365 29.8555 13.568 30.0486 13.6503 30.2219C13.7327 30.3951 13.8625 30.5415 14.0248 30.6438C14.187 30.7462 14.375 30.8004 14.5669 30.8Z",
    fill: "url(#paint10_linear_1277_371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M131.567 30.8C127.973 48.17 102.675 61.6301 72.0001 61.6301C41.3251 61.6301 16.0271 48.17 12.4331 30.8H131.567Z",
    fill: "url(#paint11_linear_1277_371)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.3999 31.0791C21.3999 31.0791 37.5279 61.6311 71.9999 61.6311",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.6 31.0791C122.6 31.0791 106.472 61.6311 72 61.6311",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.6538 31.0791C41.6538 31.0791 51.3258 61.6311 71.9998 61.6311",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.346 31.0791C102.346 31.0791 92.674 61.6311 72 61.6311",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.3999 31.0791C59.3999 31.0791 63.4169 61.6311 71.9999 61.6311",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.6 31.0791C84.6 31.0791 80.583 61.6311 72 61.6311",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.4199 39.7891H127.581",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.1108 51.082H114.89",
    stroke: "#1B1B24",
    strokeWidth: 0.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9292 114.706V122.764C47.9335 127.039 50.955 130.757 54.7292 133.593L72.0002 137.365L89.2702 133.593C93.0444 130.757 96.0658 127.039 98.0702 122.764V114.706H45.9292Z",
    fill: "url(#paint12_radial_1277_371)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7782 80.7971H49.2222V99.4711H94.7782V80.7971Z",
    fill: "url(#paint13_linear_1277_371)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0243 80.8001H48.9763L45.4873 77.3111V62.9111H98.5133V77.3111L95.0243 80.8001Z",
    fill: "url(#paint14_linear_1277_371)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4999 62.9091H44.4999L41.6499 60.0581V59.2001L43.3969 57.4531H100.597L102.344 59.2001V60.0631L99.4999 62.9091Z",
    fill: "url(#paint15_linear_1277_371)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6543 59.2001H102.346L100.598 57.4531H43.4003L41.6543 59.2001Z",
    fill: "url(#paint16_linear_1277_371)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7933 101.241L94.7783 99.472H49.2223L47.2073 101.241L45.4873 108.121H98.5133L96.7933 101.241Z",
    fill: "url(#paint17_linear_1277_371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M48.038 101.241H95.962C96.0257 101.241 96.088 101.222 96.1405 101.185C96.1929 101.149 96.233 101.098 96.2554 101.038C96.2778 100.978 96.2815 100.913 96.2658 100.851C96.2502 100.79 96.2161 100.734 96.168 100.692L94.868 99.5491C94.8106 99.4991 94.7371 99.4714 94.661 99.4711H49.34C49.2639 99.4714 49.1904 99.4991 49.133 99.5491L47.833 100.692C47.785 100.734 47.7509 100.789 47.7352 100.851C47.7195 100.913 47.7231 100.978 47.7453 101.038C47.7676 101.097 47.8076 101.149 47.8598 101.185C47.9121 101.221 47.9743 101.241 48.038 101.241Z",
    fill: "url(#paint18_linear_1277_371)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1901 106.829H82.6561L78.0861 99.4711H65.9141L61.3441 106.829H45.8101L44.373 108.121H99.626L98.1901 106.829Z",
    fill: "url(#paint19_linear_1277_371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M98.1901 106.829H82.6561L78.0861 99.4711H65.9141L61.3441 106.829H45.8101L44.373 108.121H99.626L98.1901 106.829Z",
    fill: "url(#paint20_linear_1277_371)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.815 111.423L99.6271 108.123H80.8001L77.3001 101.914H66.7001L63.2001 108.123H44.3731L42.1851 111.423C42.1851 111.48 42.1851 111.535 42.1851 111.591C42.1821 114.826 42.706 118.04 43.7361 121.107L48.9161 122.02C50.729 126.023 53.5495 129.486 57.1021 132.072L58.1431 138C62.4184 140.241 67.1732 141.411 72.0001 141.411C76.8269 141.411 81.5818 140.241 85.8571 138L86.9011 132.074C90.4536 129.488 93.2742 126.025 95.087 122.022L100.267 121.109C101.297 118.042 101.821 114.828 101.818 111.593C101.818 111.535 101.815 111.48 101.815 111.423Z",
    fill: "url(#paint21_radial_1277_371)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5811 124.814L54.0131 121.382H72.0001",
    stroke: "white",
    strokeWidth: 0.418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.419 124.814L89.987 121.382H72",
    stroke: "white",
    strokeWidth: 0.418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1631 124.245L53.595 120.813H72.0001",
    stroke: "#1B1B24",
    strokeWidth: 0.418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.837 124.245L90.405 120.813H72",
    stroke: "#1B1B24",
    strokeWidth: 0.418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2998 124.663L53.7318 121.231H71.9998",
    stroke: "#1B1B24",
    strokeWidth: 0.418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7 124.663L90.268 121.231H72",
    stroke: "#1B1B24",
    strokeWidth: 0.418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M45.4873 77.3081H98.5133L95.0243 80.7971H48.9763L45.4873 77.3081Z",
    fill: "url(#paint22_linear_1277_371)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.7368 81.9761H71.2628C70.4653 81.9761 69.8188 82.6226 69.8188 83.4201V96.8481C69.8188 97.6456 70.4653 98.2921 71.2628 98.2921H72.7368C73.5343 98.2921 74.1808 97.6456 74.1808 96.8481V83.4201C74.1808 82.6226 73.5343 81.9761 72.7368 81.9761Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7999 54.227H65.2L64.8799 54.092L62.6909 51.838L63.0109 51.082H80.991L81.3109 51.838L79.1219 54.092L78.7999 54.227Z",
    fill: "url(#paint23_linear_1277_371)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M75.735 92H68.2651L67.7061 91.44V88.824L68.2651 88.265H75.735L76.2941 88.824V91.44L75.735 92Z",
    fill: "url(#paint24_linear_1277_371)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.061 53.244V86.563L70.2311 89.733",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9391 53.244V86.563L73.769 89.733",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8572 75.2361L67.2002 84.8931H76.9392",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8572 84.8931L67.2002 75.2361",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2002 75.15L76.8572 65.493",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8572 75.15L67.2002 65.493",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8572 65.407L67.2002 55.75H76.8572L67.2002 65.407",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.061 86.563H76.939",
    stroke: "#1B1B24",
    strokeWidth: 1.114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6732 130.233H66.3273L63.4272 127.333V118.652L66.3273 115.752H77.6732L80.5732 118.652V127.333L77.6732 130.233Z",
    fill: "url(#paint25_linear_1277_371)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.0002 128.023C74.7782 128.023 77.0302 125.771 77.0302 122.993C77.0302 120.215 74.7782 117.963 72.0002 117.963C69.2222 117.963 66.9702 120.215 66.9702 122.993C66.9702 125.771 69.2222 128.023 72.0002 128.023Z",
    fill: "#00FFFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 126.98C74.2016 126.98 75.9862 125.195 75.9862 122.994C75.9862 120.793 74.2016 119.008 72.0002 119.008C69.7988 119.008 68.0142 120.793 68.0142 122.994C68.0142 125.195 69.7988 126.98 72.0002 126.98Z",
    fill: "#00FFFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 126.167C73.7531 126.167 75.1742 124.746 75.1742 122.993C75.1742 121.24 73.7531 119.819 72.0002 119.819C70.2472 119.819 68.8262 121.24 68.8262 122.993C68.8262 124.746 70.2472 126.167 72.0002 126.167Z",
    fill: "#C7FFFD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3093 119.495C66.866 119.495 67.3173 119.044 67.3173 118.487C67.3173 117.93 66.866 117.479 66.3093 117.479C65.7526 117.479 65.3013 117.93 65.3013 118.487C65.3013 119.044 65.7526 119.495 66.3093 119.495Z",
    fill: "#4A4A5B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3093 128.147C66.866 128.147 67.3173 127.696 67.3173 127.139C67.3173 126.582 66.866 126.131 66.3093 126.131C65.7526 126.131 65.3013 126.582 65.3013 127.139C65.3013 127.696 65.7526 128.147 66.3093 128.147Z",
    fill: "#4A4A5B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6901 119.495C78.2468 119.495 78.6981 119.044 78.6981 118.487C78.6981 117.93 78.2468 117.479 77.6901 117.479C77.1334 117.479 76.6821 117.93 76.6821 118.487C76.6821 119.044 77.1334 119.495 77.6901 119.495Z",
    fill: "#4A4A5B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6901 128.147C78.2468 128.147 78.6981 127.696 78.6981 127.139C78.6981 126.582 78.2468 126.131 77.6901 126.131C77.1334 126.131 76.6821 126.582 76.6821 127.139C76.6821 127.696 77.1334 128.147 77.6901 128.147Z",
    fill: "#4A4A5B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M41.6537 71.488L36.0957 77.046",
    stroke: "white",
    strokeWidth: 0.418,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.9819 82.599H35.1479",
    stroke: "white",
    strokeWidth: 0.418,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.9819 86.448H35.1479",
    stroke: "white",
    strokeWidth: 0.418,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1277_371",
    x1: 0.991699,
    y1: 39.9442,
    x2: 17.4551,
    y2: 39.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#65657E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#727289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#7A7A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#7D7D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7B7B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#686881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1277_371",
    x1: 3211.53,
    y1: 39.9442,
    x2: 3228,
    y2: 39.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#65657E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#727289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#7A7A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#7D7D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7B7B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#686881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1277_371",
    x1: 41.8735,
    y1: 24.2821,
    x2: 39.0996,
    y2: 23.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1277_371",
    x1: 2854.81,
    y1: 24.2821,
    x2: 2852.04,
    y2: 23.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1277_371",
    x1: 59.395,
    y1: 22.0295,
    x2: 84.606,
    y2: 22.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1277_371",
    x1: 119.467,
    y1: -18.6491,
    x2: 119.467,
    y2: -28.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1277_371",
    x1: 44.3051,
    y1: 75.1501,
    x2: 44.3051,
    y2: 65.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1277_371",
    x1: 3165.26,
    y1: 431.429,
    x2: 3165.26,
    y2: 421.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1277_371",
    x1: 3123.17,
    y1: 75.1501,
    x2: 3123.17,
    y2: 65.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1277_371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-604.231 -122.284) scale(60.2729 40.9798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1277_371",
    x1: 13.5522,
    y1: 28.6711,
    x2: 130.447,
    y2: 28.6711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1277_371",
    x1: 72.0001,
    y1: 30.3684,
    x2: 72.0001,
    y2: 57.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1277_371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-469.913 106.254) scale(27.0361 27.0095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1277_371",
    x1: 49.6777,
    y1: 90.1341,
    x2: 94.4137,
    y2: 90.1341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1277_371",
    x1: 45.5934,
    y1: 71.8556,
    x2: 98.0891,
    y2: 71.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#65657E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#727289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#7A7A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#7D7D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7B7B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#686881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1277_371",
    x1: 71.9969,
    y1: 54.6597,
    x2: 71.9969,
    y2: 46.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1277_371",
    x1: 72.0003,
    y1: 57.3116,
    x2: 72.0003,
    y2: 58.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1277_371",
    x1: 72.0003,
    y1: 98.192,
    x2: 72.0003,
    y2: 88.4965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1277_371",
    x1: 47.7256,
    y1: 100.356,
    x2: 96.2754,
    y2: 100.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1277_371",
    x1: 71.5023,
    y1: 85.51,
    x2: 71.5063,
    y2: 92.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1277_371",
    x1: 71.1707,
    y1: 84.7834,
    x2: 71.1775,
    y2: 93.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1277_371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-252.586 112.657) scale(27.1207 27.1344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#7B7B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#686881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1277_371",
    x1: 72.0003,
    y1: 80.7971,
    x2: 72.0003,
    y2: 77.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1277_371",
    x1: 62.6909,
    y1: 52.6545,
    x2: 81.3109,
    y2: 52.6545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1277_371",
    x1: 72.0001,
    y1: 96.6202,
    x2: 72.0001,
    y2: 94.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1277_371",
    x1: 72.0002,
    y1: 130.233,
    x2: 72.0002,
    y2: 115.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractorBeam3);
export default __webpack_public_path__ + "static/media/tractorBeam3.62b1a1870a47050bcb383c70a56f5efa.svg";
export { ForwardRef as ReactComponent };